import { useSyncExternalStore } from "react";

import { readPref, subscribePref, writePref } from "../prefs";
import { familyById } from "./families";
import type { ThemeFamily } from "./family";

// The family this browser shows, kept in the `theme` pref: read before the first render, so a
// chosen family paints with the page, and changed by showTheme here or by another tab.
const listeners = new Set<() => void>();

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  const fromOtherTabs = subscribePref("theme", listener);
  return () => {
    listeners.delete(listener);
    fromOtherTabs();
  };
}

/** The family to show: the `theme` pref's, or Created.ai when it names no family. */
export function useThemeFamily(): ThemeFamily {
  return familyById(useSyncExternalStore(subscribe, () => readPref("theme")));
}

/** Shows family `id` in this tab and the browser's others. */
export function showTheme(id: string): void {
  writePref("theme", id);
  for (const listener of listeners) listener();
}
